import React, { useRef, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ToraiIcon from '../assets/logos/FramSys_Logo2_LT.png';
import HamburgerIcon from '../assets/misc/burger.svg'; // Ensure this is a hamburger icon
import '../styles/header.css';

const Header = ({ children }) => {
  const location = useLocation();
  const timeoutRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (location.hash) {
      timeoutRef.current = setTimeout(() => scrollToSection(location.hash), 0);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const scrollToSection = (hash) => {
    const id = hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <header className="sticky-header">
        <div className="header-content">
          <Link className="logo-container" to="/">
            <img src={ToraiIcon} alt="FramSys Logo" className="logo" />
          </Link>
          <button className="burger" onClick={toggleMenu}>
            <img src={HamburgerIcon} alt="Menu" />
          </button>
          <div ref={menuRef} className={`header-links ${isMenuOpen ? 'show' : ''}`}>
            <Link to="/" className={`header-object ${isActive('/') ? 'active' : ''}`} onClick={closeMenu}>
              Home
            </Link>
            <div className="dropdown-container">
                <Link to="/metric-generator" className={`header-object dropdown-toggle ${isActive('/metric-generator') ? 'active' : ''}`} onClick={closeMenu}>
                    AI Sensor
                </Link>
                <div className="dropdown-menu">
                    <Link to="/metric-generator#overview" onClick={closeMenu}>Overview</Link>
                    <Link to="/metric-generator#reports" onClick={closeMenu}>Reports</Link>
                    <Link to="/metric-generator#data" onClick={closeMenu}>Data</Link>
                    <Link to="/metric-generator#pricing" onClick={closeMenu}>Pricing</Link>
                    <Link to="/metric-generator#setup" onClick={closeMenu}>Setup</Link>
                </div>
            </div>

                   <div className="dropdown-container">
                <Link to="/about" className={`header-object dropdown-toggle ${isActive('/about') ? 'active' : ''}`} onClick={closeMenu}>
                    About
                </Link>
                <div className="dropdown-menu">
                    <Link to="/about" onClick={closeMenu}>About us</Link>
                    <Link to="/privacy-policy" onClick={closeMenu}>Privacy policy</Link>
                </div>
            </div>


            {/* <Link to="/about" className={`header-object ${isActive('/about') ? 'active' : ''}`} onClick={closeMenu}>
              About
            </Link> */}
            <Link to="/contact" className={`header-object ${isActive('/contact') ? 'active' : ''}`} onClick={closeMenu}>
              Contact
            </Link>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </>
  );
};

export default Header;
